import { CSSProcessor } from './CSSProcessor';
export { CSSProcessedProps } from './CSSProcessedProps';
export * from './config';
export * from './default';
export * from './processor-types';
export * from './property-types';
export * from './native-types';
export { default as mergeProps } from './mergeProps';
export { CSSProcessor };
export type {
  CSSFlattenProcessedTypes,
  MixedSizeCSSPropertiesKeys,
  MixedStyleDeclaration
} from './CSSProcessor';
export default CSSProcessor;
